import React from 'react';
import { SinglePropertyView } from '@domain-group/fe-pa-allhomes-listing-details';
import StandardPage from './common/standard-page.js';

/* eslint-disable react/jsx-filename-extension */

const ListingDetailsPage = (props) => (
  <StandardPage component={SinglePropertyView} {...props} />
);

export default ListingDetailsPage;
